/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Policy_LinkInputs */

const en_mk_team_policy_link = /** @type {(inputs: Mk_Team_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the status of each provider`)
};

const id_mk_team_policy_link = /** @type {(inputs: Mk_Team_Policy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat status tiap penyedia`)
};

/**
* | output |
* | --- |
* | "See the status of each provider" |
*
* @param {Mk_Team_Policy_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_policy_link = /** @type {((inputs?: Mk_Team_Policy_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Policy_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_policy_link(inputs)
	return en_mk_team_policy_link(inputs)
});